/// ----------------------------------------------------------------------------------------
///Copyright (C) 2016 to the present, Crestron Electronics, Inc.
///All rights reserved.
///No part of this software may be reproduced in any form, machine
///or natural, without the express written consent of Crestron Electronics.
/// ----------------------------------------------------------------------------------------
/// <file>
/// <name>base-detail.component.ts</name>
///
/// <description>
///
/// </description>
///
/// <author>Michael Martinez</author>
/// <created>22 Feb 2018</created>
///
/// <changelog>
///   Date  Who Version     Flag Comments
/// ======= === =========== ==== ===========================================================
/// </changelog>



import { Component, OnInit, Input, Output } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Router, ActivatedRoute, Params, NavigationEnd } from '@angular/router';

import { Subscription } from "rxjs/Subscription";
import { TimerObservable } from "rxjs/observable/TimerObservable";

import { hydUtilService} from "../../../utils/hydUtils.service";
import { BreadcrumbModule, Breadcrumb, ButtonModule, CalendarModule, MenuItem, Message, MenuModule, PanelModule, TabPanel, TabView } from 'primeng/primeng';

import { MediatorService } from '../../../services/mediator.service';
import { MediatorEventLookup } from '../../../services/mediator-event-lookup.service';
import { CUIDetailComponent } from '../../../shared/cui-detail/cui-detail.component';
import { CUIFeatureInterface } from '../../../interfaces/cui-feature.interface';
import { CUIGridColumn } from '../../../shared/cui-grid/cui-grid-column';
import { TranslatedStringsService } from '../../../services/language.service';
//YH 3/17/2017 Bug 124601
import { HydrogenAppConfigService } from '../../../host.config.service';
import * as moment from 'moment';
import {BaseCommunicationService} from  '../base-communication.service';


@Component({
    selector: 'base-detail',
    templateUrl: './base-detail.component.html'
})
export class BaseDetailComponent implements CUIFeatureInterface {

    private baseObject: any = { name: "Base Component" };
    private actionsBtnLbl: string;
    private actions: MenuItem[] = [];

    constructor(protected communicationService: BaseCommunicationService,
        private route: ActivatedRoute,
        private i18n: TranslatedStringsService,
        private mediator: MediatorService,
        private router: Router,
        private configSvc: HydrogenAppConfigService
    ) {
    }

    //----------------------------------------------------------
    //Implementations of Interface
    //----------------------------------------------------------
    ngOnChanges(changes: any) { };
    ngDoCheck() { };
    ngAfterContentInit() { };
    ngAfterContentChecked() { };
    ngAfterViewInit() { };
    ngAfterViewChecked() { };

    //-----------------------------------------------
    // ngOnInit
    //-----------------------------------------------
    ngOnInit() {
        this.translate();
        this.Start();
    }



    //-----------------------------------------------
    // ngOnDestroy
    //-----------------------------------------------
    ngOnDestroy() {


    }

    //-----------------------------------------------
    // translate
    //-----------------------------------------------
    private translate() {

    }

    //-----------------------------------------------
    // Start
    //-----------------------------------------------
    private Start() {
        this.buildActionsMenu();

    }

    //-----------------------------------------------
    // buildActionsMenu
    //-----------------------------------------------
    private buildActionsMenu() {

        this.actionsBtnLbl = this.i18n.translate("account-action");
        this.actions = [];
        this.actions.push({ label: this.i18n.translate("base-action-1"), icon: "fa-bolt", command: () => { this.action1(); } });
        this.actions.push({ label: this.i18n.translate("base-action-2"), icon: "fa-bolt", command: () => { this.action2(); } });


    }


    //-----------------------------------------------
    // action1
    //-----------------------------------------------
    private action1() {


    }

    //-----------------------------------------------
    // action2
    //-----------------------------------------------
    private action2() {


    }




}



// WEBPACK FOOTER //
// C:/WS/Fusion/FusionDashboard/src/app/features/base-component/base-detail/base-detail.component.ts